/**
 * Splits the string value by spaces
 *
 * @internal
 */
export function splitStringValue(value) {
    value = value || [];
    if (Array.isArray(value)) {
        return value;
    }
    return value === ""
        ? []
        : value.trim().split(/ +/);
}
